import React, { useEffect, useState, useRef } from 'react';
import {
  Modal,
  Col,
  Typography,
  Form,
  Row,
  Layout,
  Input,
  Button,
  message,
  Spin,
  Space,
  Table,
  Tooltip,
  DatePicker,
  Select,
  InputNumber,
  Upload,
  notification,
  Image,
  Radio,
  Checkbox,
  Drawer,
} from 'antd';
import {
  FilePdfOutlined,
  MailOutlined,
  EditOutlined,
  DeleteOutlined,
  ShareAltOutlined,
  CloudUploadOutlined,
  FileTextOutlined,
  ArrowLeftOutlined,
  FileImageOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import {
  DownloadOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  UndoOutlined,
  CopyOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import axios from 'axios';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { connect } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import get from 'lodash/get';
import axiosConfig from '../../redux/heatProfile/heatProfileAxiosConfig';
import omit from 'lodash/omit';
import EmailModal from '../EmailModal';
import AntdImageViewer from './Imageviewer';
import ImageWithCustomToolbar from './Imageviewer';
import { fetchProjectHeatProfileList } from '../../redux/projectHeatProfile/action';
import styled from 'styled-components';
import { NotifyEmails } from '../../redux/heatProfile/saga';
import SignaturePad from './Signature_Pad';
import { Content, Footer } from 'antd/lib/layout/layout';
const { Title, Text } = Typography;

const ProjectHeatProfilePDFViewer = (props) => {
  const { id } = useParams();
  const history = useHistory();

  const { onProjectList, projectList, isLoading, listCount } = props;

  const fileInputRef = useRef(null);
  const user = JSON.parse(localStorage.getItem('user'));
  let name;
  if (user.name) {
    name = user.name;
  } else {
    name = user['custom:first_name'] + ' ' + user['custom:last_name'];
  }

  const validation_fields = {
    reportNumber: 'Report Number',
    projectName: 'Project Name',
    projectNumber: 'Project Number',
    trailDate: 'Trial Date',
    generatorId: 'Generator Id',
    inductionCoilId: 'Induction Coil ID',
    steelOD: 'Steel OD',
    wt: 'Wt',
    generatorSettings: 'Generator Settings',
    coilLength: 'CoilLength',
    cableLength: 'Cable length',
    numberOfTurns: 'Number of Turns',
    materialClass: 'Material Class',
    material: 'Material',
    cutbackLength: 'Cut back Length',
    parentCoatingThickness: 'Parent Coating Thickness',
    probeTemp: 'Probe Temp',
    probeTempLocation: 'Probe temp Location',
  };

  const initialFormState = {
    reportNumber: '',
    projectName: '',
    projectNumber: '',
    reportAuthor: name,
    trailDate: '',
    generatorId: '',
    inductionCoilId: '',
    steelOD: '',
    wt: '',
    //
    generatorSettings: '',
    coilLength: '',
    cableLength: '',
    numberOfTurns: '',
    //
    materialClass: '',
    material: '',
    stages: 1,
    maxTemp: '0',
    minTemp: '0',
    maxTempS1: '0',
    minTempS1: '0',
    //
    cutbackLength: '',
    parentCoatingThickness: '',
    probeTemp: '',
    probeTempLocation: '',
    //
    signatureRequired: 0,

    deployEnv: process.env.REACT_APP_STAGE,
    imageFileDetails: {},
    required: {
      generatorSettings: 'Yes',
      coilLength: 'Yes',
      cableLength: 'Yes',
      numberOfTurns: 'Yes',
    },
    units: {
      steelOD: 'mm',
      wt: 'mm',
      coilLength: 'mm',
      cableLength: 'meters',
      parentCoatingThickness: 'mm',
    },
  };
  const { Option } = Select;
  const temperatureUnit = '°C';
  const lengthUnit = 'mm';

  const Units = [{ value: 'mm' }, { value: 'inch' }];
  const materialClassOptions = [
    'FBE',
    'Liquid Epoxy',
    'Single Layer FBE',
    ,
    'Dual Layer FBE',
    'Others',
  ];

  const materialOptions = {
    FBE: [
      'Pipeclad 2000 Slow Gel',
      'Pipeclad 2000 LAT',
      'Pipeclad Hot 150',
      'Pipeclad Hot 150 Flex',
      'Pipeclad Hot 12',
      'Pipeclad Hot 120 Flex',
      'Axalta Nap-Gard',
      'Jotapipe AC 1003 XT',
    ],
    'Liquid Epoxy': ['Canusa Liquid Epoxy Type P'],
    'Single Layer FBE': ['Axalta Nap-Gard 72555LG'],
    'Dual Layer FBE': ['Axalta Nap-Gard 7-2675'],
    // 'Others': ['One-stage', 'Two-stage'],
  };

  const predefinedTemperatureRanges = {
    'Pipeclad 2000 Slow Gel': { min: 205, max: 240 },
    'Pipeclad 2000 LAT': { min: 175, max: 210 },
    'Pipeclad Hot 150': { min: 204, max: 240 },
    'Pipeclad Hot 150 Flex': { min: 204, max: 240 },
    'Pipeclad Hot 12': { min: 205, max: 240 },
    'Pipeclad Hot 120 Flex': { min: 205, max: 240 },
    'Canusa Liquid Epoxy Type P': { min: 175, max: 210, minS1: 30, maxS1: 60 },
    'Axalta Nap-Gard': { min: 218, max: 239, minS1: 0, maxS1: 180 },
    'Axalta Nap-Gard 72555LG': { min: 225, max: 239 },
    'Axalta Nap-Gard 7-2675': { min: 218, max: 239 },
    'Jotapipe AC 1003 XT': { min: 232, max: 250 },
  };

  const { Column, ColumnGroup } = Table;
  const { Title } = Typography;
  const [formData, setFormData] = useState(initialFormState);
  const [selectedFile, setSelectedFile] = useState(null);
  const [outputFile, setOutputFile] = useState('');
  const [loading, setLoading] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [selectedHeatProfileRow, setSelectedHeatProfileRow] = useState(null);
  const [emailModalVisible, setEmailModalVisible] = useState(false);
  const [emailListId, setEmailListId] = useState('');
  const [shareButtonVisible, setShareButtonVisible] = useState(false);
  const [pdfReportDetails, setPDFReportDetails] = useState([]);
  const [textFileDetails, setTextFileDetails] = useState([]);
  const [inputFile, setInputFile] = useState('');
  const [fileList, setFileList] = useState([]);
  const [showPDFViewer, setShowPDFViewer] = useState(true);
  const [selectedViewRow, setSelectedViewRow] = useState('');
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [signatureReq, setSignatureReq] = useState(0);
  const [currentImage, setCurrentImage] = useState(1);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImage] = useState([]);
  const [steelODUnit, setSteelODUnit] = useState('mm');
  const [wtUnits, setWtUnits] = useState('mm');
  const [coilLengthUnit, setCoilLengthUnit] = useState('mm');
  const [cableUnit, setcableUnit] = useState('meters');
  const [parentCoatingThicknessUnit, setParentCoatingThicknessUnit] = useState('mm');
  const [editedFields, setEditedFields] = useState({});
  const [isInputfeildChanged, setIsInputfeildChanged] = useState(false);
  const [OpenSignaturePad, setOpenSignaturePad] = useState(false);
  const [SignatureSaveLoading, setSignatureSaveLoading] = useState(false);
  const [isGenerated, setIsGenerated] = useState(false);
  const [SignatureData, setSignatureData] = useState('');
  const [ReviewAndSign, setReviewAndSign] = useState(false);
  const [isOtherMaterialClass, setIsOtherMaterialClass] = useState(false);
  const [form] = Form.useForm();

  console.log('ProjectHeatProfilePDFViewer mounted with id:', id);
  console.log('Current pathname:', window.location.pathname);

  useEffect(() => {
    console.log('ProjectHeatProfilePDFViewer component mounted');
    return () => {
      console.log('ProjectHeatProfilePDFViewer component unmounted');
    };
  }, []);

  // Auto-load the specific record when component mounts
  useEffect(() => {
    const fetchRecord = async () => {
      try {
        setLoading(true);
        // For project heat profile, fetch directly by ID
        const response = await axiosConfig.get(`/project-heat-profile/${id}`);
        if (response.data && response.data.data) {
          setSelectedHeatProfileRow(response.data.data);

          // Set PDF URL if available
          if (response.data.data.pdfReportDetails && response.data.data.pdfReportDetails.s3Url) {
            setOutputFile(response.data.data.pdfReportDetails.s3Url);
            setShowPDFViewer(true);
          }

          // Download text file if available
          if (response.data.data.textFileDetails?.s3Url) {
            await handleDownloadAndSetFile(response.data.data.textFileDetails);
          }
        } else {
          notification.error({
            message: 'Record not found',
            description: `No project heat profile record found with ID: ${id}`,
          });
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching project heat profile:', error);
        notification.error({
          message: 'Error loading data',
          description: 'Failed to load the project heat profile. Please try again.',
        });
        setLoading(false);
      }
    };

    if (id) {
      fetchRecord();
    }
  }, [id]);

  useEffect(() => {
    const OpenView = async () => {
      if (ReviewAndSign && !isLoading) {
        if (
          formData &&
          formData['signatureRequired'] &&
          formData['signatureRequired'] == 1 &&
          selectedHeatProfileRow
        ) {
          setSelectedViewRow(selectedHeatProfileRow);
        }
        setReviewAndSign(false);
      }
    };
    OpenView();
  }, [ReviewAndSign]);

  // Function to download and set file
  const handleDownloadAndSetFile = async (s3KeysValue) => {
    try {
      const response = await fetch(s3KeysValue.s3Url);
      const blob = await response.blob();

      const downloadedFile = new File([blob], s3KeysValue.fileName);
      setFileList(['abc.txt']);
      setInputFile(s3KeysValue.s3Url);
      setSelectedFile(downloadedFile);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const onClickImageView = async (record) => {
    setSelectedViewRow(record);
    setIsViewerOpen(true);
  };

  const handleReviewAndSign = async () => {
    setReviewAndSign(true);
  };

  //email popup maintain
  const handleAddEmailClick = async () => {
    setEmailModalVisible(true);
  };

  const handleEmailModalCancel = () => {
    setEmailModalVisible(false);
    setEmailListId('');
  };

  //update List data for project heat profile
  const updateListData = async (reportUrlObject, txtFileInfo) => {
    setLoading(true);
    const payload = {
      heatProfile: {
        ...omit(formData, 'customMaterialClass'),
        pdfReportDetails: reportUrlObject.Report_s3Url,
        textFileDetails: txtFileInfo,
        imageFileDetails: reportUrlObject.Image_s3Url,
      },
    };

    try {
      const response = await axiosConfig.put(`/project-heat-profile/${id}`, payload);
      message.success(`Data updated successfully`);
      setEmailListId(id);
      setShareButtonVisible(true);

      if (formData['signatureRequired'] && formData['signatureRequired'] == true) {
        setIsGenerated(true);
      }

      await NotifyEmails(formData, true);
    } catch (error) {
      console.error('Error submitting data:', error);
      message.error(`Data update failed.`);
    }
    setLoading(false);
  };

  //TextFile conversion api call with Data
  const handleChange = async (info) => {
    const invalidChars = /[<>:"/\\|?*']/;
    const { status, name, originFileObj } = info.file;

    if (status) {
      if (invalidChars.test(name)) {
        notification.warning({
          message: 'Invalid File Name',
          description: 'The file name contains invalid characters: < > : " / \\ | ? * \'',
        });
        // Optionally, you can clear the file list if an invalid file is selected
        setFileList([]);
      } else {
        setSelectedFile(originFileObj);
        setFileList([info.file]);
        setIsInputfeildChanged(true);
      }
    } else if (status === 'error') {
      console.error(`${name} file upload failed.`);
    }
  };

  // Handle signature functionality
  const onGenerateSignedPdf = async (category, type, values) => {
    setSignatureData((prevOptions) => {
      return {
        ...prevOptions,
        [category]: {
          ...prevOptions[category],
          [type]: values,
        },
      };
    });
  };

  const GeneratePDFWith_sign = async () => {
    if (
      (SignatureData['preparedBySign'] &&
        ((SignatureData['preparedBySign'].Image && !SignatureData['preparedBySign'].Name) ||
          (!SignatureData['preparedBySign'].Image && SignatureData['preparedBySign'].Name))) ||
      (SignatureData['approvedBySign'] &&
        ((SignatureData['approvedBySign'].Image && !SignatureData['approvedBySign'].Name) ||
          (!SignatureData['approvedBySign'].Image && SignatureData['approvedBySign'].Name))) ||
      (SignatureData['approved2BySign'] &&
        ((SignatureData['approved2BySign'].Image && !SignatureData['approved2BySign'].Name) ||
          (!SignatureData['approved2BySign'].Image && SignatureData['approved2BySign'].Name)))
    ) {
      message.error(`Please fill the required field`);
      return;
    }

    setSignatureSaveLoading(true);
    if (
      !SignatureData['preparedBySign'] &&
      selectedViewRow.pdfReportDetails?.preparedBySign?.IsSigned
    ) {
      SignatureData['preparedBySign'] = selectedViewRow.pdfReportDetails?.preparedBySign;
    }
    if (
      !SignatureData['approvedBySign'] &&
      selectedViewRow.pdfReportDetails?.approvedBySign?.IsSigned
    ) {
      SignatureData['approvedBySign'] = selectedViewRow.pdfReportDetails?.approvedBySign;
    }
    if (
      !SignatureData['approved2BySign'] &&
      selectedViewRow.pdfReportDetails?.approved2BySign?.IsSigned
    ) {
      SignatureData['approved2BySign'] = selectedViewRow.pdfReportDetails?.approved2BySign;
    }

    if (selectedFile && SignatureData !== '') {
      const updatedFormData = new FormData();
      const heatprofiledata = {};

      // Helper function to append units to specific keys
      const appendUnit = (key, value) => `${value} ${formData.units[key]}`;

      // Iterate over formData entries
      Object.entries(formData).forEach(([key, value]) => {
        // Handle specific keys requiring unit appending
        const unitKeys = ['steelOD', 'coilLength', 'wt', 'cableLength', 'parentCoatingThickness'];
        if (unitKeys.includes(key)) {
          value = appendUnit(key, value);
        }

        // Handle boolean conversion for `signatureRequired`
        if (key === 'signatureRequired' && value === false) {
          value = 'False';
        }

        // Handle JSON conversion for `required`
        if (key === 'required') {
          value = JSON.stringify(value);
        }

        // Update heatprofiledata and FormData
        heatprofiledata[key] = value;
        updatedFormData.append(key, value);
      });

      Object.entries(SignatureData).forEach(([key, value]) => {
        heatprofiledata[key] = value;

        if (key == 'preparedBySign') {
          if (SignatureData.preparedBySign['Image'] && !value.Date) {
            value.Date = moment().utc().format('DD-MMM-YYYY HH:mm');
            SignatureData.preparedBySign['Date'] = value.Date;
          }
          value = JSON.stringify(value);
        }

        if (key == 'approvedBySign') {
          if (SignatureData.approvedBySign['Image'] && !value.Date) {
            (value.Date = moment().utc().format('DD-MMM-YYYY HH:mm')),
              (SignatureData.approvedBySign['Date'] = value.Date);
          }
          value = JSON.stringify(value);
        }
        if (key == 'approved2BySign') {
          if (SignatureData.approved2BySign['Image'] && !value.Date) {
            (value.Date = moment().utc().format('DD-MMM-YYYY HH:mm')),
              (SignatureData.approved2BySign['Date'] = value.Date);
          }
          value = JSON.stringify(value);
        }

        updatedFormData.append(key, value);
      });

      updatedFormData.append('file', selectedFile);
      if (formData.units.GeneratedDate)
        updatedFormData.append('GeneratedDate', formData.units.GeneratedDate);

      try {
        const response = await axios.post(
          process.env.REACT_APP_AWS_HEAT_PROFILE_REPORT_GENERATOR,
          updatedFormData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        const reportUrlObject = response.data.report_url;

        // Mark the report as signed
        reportUrlObject.Report_s3Url['IsSigned'] = true;

        // Add `preparedBySign` if both Image and Name are present
        if (
          SignatureData['preparedBySign'] &&
          SignatureData['preparedBySign']?.Image &&
          SignatureData['preparedBySign']?.Name
        ) {
          reportUrlObject.Report_s3Url['preparedBySign'] = {
            ...SignatureData['preparedBySign'],
            IsSigned: true,
          };
          selectedViewRow.pdfReportDetails['preparedBySign'] =
            reportUrlObject.Report_s3Url['preparedBySign'];
        }

        // Add `approvedBySign` if both Image and Name are present
        if (
          SignatureData['approvedBySign'] &&
          SignatureData['approvedBySign']?.Image &&
          SignatureData['approvedBySign']?.Name
        ) {
          reportUrlObject.Report_s3Url['approvedBySign'] = {
            ...SignatureData['approvedBySign'],
            IsSigned: true,
          };
          selectedViewRow.pdfReportDetails['approvedBySign'] =
            reportUrlObject.Report_s3Url['approvedBySign'];
        }

        // Add `approved2BySign` if both Image and Name are present
        if (
          SignatureData['approved2BySign'] &&
          SignatureData['approved2BySign']?.Image &&
          SignatureData['approved2BySign']?.Name
        ) {
          reportUrlObject.Report_s3Url['approved2BySign'] = {
            ...SignatureData['approved2BySign'],
            IsSigned: true,
          };
          selectedViewRow.pdfReportDetails['approved2BySign'] =
            reportUrlObject.Report_s3Url['approved2BySign'];
        }
        // Update the URL details in `selectedViewRow`
        selectedViewRow.pdfReportDetails.s3Url = reportUrlObject.Report_s3Url.s3Url;

        // Update the state and other references
        setSelectedViewRow({ ...selectedViewRow });
        setPDFReportDetails({ ...reportUrlObject.Report_s3Url });
        setOutputFile(reportUrlObject.Report_s3Url.s3Url);

        const payload = {
          heatProfile: {
            ...omit(selectedViewRow, 'customMaterialClass'),
            pdfReportDetails: reportUrlObject.Report_s3Url,
          },
        };
        try {
          const response = await axiosConfig.put(`/project-heat-profile/${id}`, payload);
          message.success(`Data updated successfully`);
        } catch (error) {
          console.error('Error submitting data:', error);
          message.error(`Data update failed.`);
        }
        setOpenSignaturePad(false);
        closeDrawer();
      } catch (error) {
        console.error('Error:', error);
        message.error('Failed to generate signed PDF');
      }
    }
    setSignatureSaveLoading(false);
  };

  const uploadFileToS3 = async (selectedFile) => {
    try {
      const textFileTos3Response = await axiosConfig.get(
        `/project-heat-profile/signed-url?fileName=${selectedFile.name}&deployEnv=${process.env.REACT_APP_STAGE}`
      );
      if (textFileTos3Response.status === 200) {
        const textFileTos3 = textFileTos3Response.data;
        const uploadPresignedUrlResponse = await axios.put(
          textFileTos3.data.preSignedUrl,
          selectedFile,
          {
            headers: {
              'Content-Disposition': 'attachment',
              'Content-Type': 'text/plain',
            },
          }
        );

        if (uploadPresignedUrlResponse.status === 200) {
          const fileInfo = {
            s3Url: textFileTos3.data.s3Url,
            fileName: textFileTos3.data.fileName,
            s3Key: textFileTos3.data.s3Key,
          };

          setTextFileDetails(fileInfo);
          return fileInfo;
        } else {
          console.error('Error uploading file to presigned URL:', uploadPresignedUrlResponse);
        }
      } else {
        console.error('Error getting signed URL:', textFileTos3Response);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  //generate Pdf
  const generatePdf = async () => {
    const missingFields = Object.keys(formData).filter((key) => {
      if (
        (key === 'material' || key === 'customMaterialClass') &&
        formData.materialClass != 'Liquid Epoxy' &&
        formData.materialClass != 'FBE'
      ) {
        return false;
      }
      return formData[key] === '';
    });

    if (missingFields.includes('material') && formData.material === '' && isOtherMaterialClass)
      missingFields.splice(missingFields.indexOf('material'), 1);

    if (missingFields.includes('customMaterialClass')) {
      missingFields.splice(missingFields.indexOf('customMaterialClass'), 1);
    }

    if (missingFields.includes('approvedBySign')) {
      missingFields.splice(missingFields.indexOf('approvedBySign'), 1);
    }
    if (missingFields.includes('approved2BySign')) {
      missingFields.splice(missingFields.indexOf('approved2BySign'), 1);
    }
    if (missingFields.includes('preparedBySign')) {
      missingFields.splice(missingFields.indexOf('preparedBySign'), 1);
    }
    if (missingFields.includes('generatorSettings')) {
      if (formData.required.generatorSettings === 'No') {
        missingFields.splice(missingFields.indexOf('generatorSettings'), 1);
      }
    }

    if (missingFields.includes('coilLength')) {
      if (formData.required.coilLength === 'No') {
        missingFields.splice(missingFields.indexOf('coilLength'), 1);
      }
    }

    if (missingFields.includes('cableLength')) {
      if (formData.required.cableLength === 'No') {
        missingFields.splice(missingFields.indexOf('cableLength'), 1);
      }
    }

    if (missingFields.includes('numberOfTurns')) {
      if (formData.required.numberOfTurns === 'No') {
        missingFields.splice(missingFields.indexOf('numberOfTurns'), 1);
      }
    }

    if (missingFields.length > 10) {
      const missingFieldNames = missingFields.map((field) => validation_fields[field]);
      console.log(missingFields, missingFieldNames);
      message.error(`Please fill in the following fields: ${missingFieldNames.join(', ')}`);
      return;
    } else if (missingFields.length > 0) {
      message.error(`Please fill the required fields`);
      console.log(missingFields);
      return;
    }

    if (formData.minTemp > formData.maxTemp) {
      message.error(`MinTemp is must be lesser or equal to ${formData.maxTemp}`);
      return;
    }

    if (formData.minTempS1 > formData.maxTempS1) {
      message.error(`MinTempS1 is must be lesser or equal to ${formData.maxTempS1}`);
      return;
    }

    setLoading(true);

    if (selectedFile) {
      const updatedFormData = new FormData();
      let heatprofiledata = {};
      // Helper function to append units to specific keys
      const appendUnit = (key, value) => `${value} ${formData.units[key]}`;

      // Iterate over formData entries
      Object.entries(formData).forEach(([key, value]) => {
        // Handle specific keys requiring unit appending
        const unitKeys = ['steelOD', 'coilLength', 'wt', 'cableLength', 'parentCoatingThickness'];
        if (unitKeys.includes(key)) {
          value = appendUnit(key, value);
        }

        if (key == 'signatureRequired' && value == false) {
          value = 'False';
        }

        heatprofiledata[key] = value;
        if (key == 'required') {
          value = JSON.stringify(value);
        }
        updatedFormData.append(key, value);
      });
      updatedFormData.append('file', selectedFile);
      updatedFormData.append('GeneratedDate', moment().utc().format('DD-MMM-YYYY HH:mm'));
      formData.units['GeneratedDate'] = moment().utc().format('DD-MMM-YYYY HH:mm');

      try {
        const txtFileInfo = await uploadFileToS3(selectedFile);

        const response = await axios.post(
          process.env.REACT_APP_AWS_HEAT_PROFILE_REPORT_GENERATOR,
          updatedFormData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        const reportUrlObject = response.data.report_url;

        setPDFReportDetails(reportUrlObject.Report_s3Url);
        setOutputFile(reportUrlObject.Report_s3Url.s3Url);
        await updateListData(reportUrlObject, txtFileInfo);
        if (formData['signatureRequired'] && formData['signatureRequired'] == true) {
          setIsGenerated(true);
        }
      } catch (error) {
        console.error('Error:', error);
        message.error(`${selectedFile.name} file upload failed. 
                Please select a valid  file to upload`);
      }
    } else {
      message.error('Please select a valid file');
    }
    setLoading(false);
  };

  //sent fileUrl to  emails
  const handleEmailSent = async (emails) => {
    const payload = {
      emailDetails: {
        toAddresses: emails,
        heatProfileId: emailListId,
      },
    };

    try {
      const response = await axiosConfig.post('/project-heat-profile/report', payload);
      message.success(`File will be sent to your e-mail shortly!`);
      handleEmailModalCancel();
    } catch (error) {
      console.error('Error submitting data:', error);
      message.error(`Please type valid EmailId!`);
    }
  };

  const closeDrawer = () => {
    setSignatureData('');
    setOpenSignaturePad(false);
  };

  const closeImageViewer = () => {
    setCurrentImage(0);
    setShowPDFViewer(false);
  };

  return (
    <div className="d-flex flex-column h-100">
      <div className="flex-auto">
        {/* Show loading state while fetching data */}
        {loading && !selectedHeatProfileRow && (
          <div className="flex-auto">
            <div className="d-flex mb-3 align-items-center tab-content-title">
              <div className="back_heatp_modal">
                <Tooltip title={'Back'}>
                  <ArrowLeftOutlined
                    onClick={() => {
                      history.goBack();
                    }}
                  />
                </Tooltip>
              </div>
              <Title
                className="mb-0 add-new-calibration"
                level={3}
                style={{ paddingLeft: '25px', paddingTop: '5px' }}
              >
                Loading Project Heat Profile PDF Viewer...
              </Title>
            </div>
            <div className="custom-line" />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
              }}
            >
              <Spin size="large" />
            </div>
          </div>
        )}

        {/* Show error if record not found */}
        {!loading && !selectedHeatProfileRow && (
          <div className="flex-auto">
            <div className="d-flex mb-3 align-items-center tab-content-title">
              <div className="back_heatp_modal">
                <Tooltip title={'Back'}>
                  <ArrowLeftOutlined
                    onClick={() => {
                      history.goBack();
                    }}
                  />
                </Tooltip>
              </div>
              <Title
                className="mb-0 add-new-calibration"
                level={3}
                style={{ paddingLeft: '25px', paddingTop: '5px' }}
              >
                Record Not Found
              </Title>
            </div>
            <div className="custom-line" />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
              }}
            >
              <div>The requested project heat profile record could not be found.</div>
            </div>
          </div>
        )}

        {/* Show PDF viewer when record is loaded */}
        {showPDFViewer && selectedHeatProfileRow && outputFile && (
          <div className="d-flex flex-column h-100">
            <div className="flex-auto">
              <div>
                <div className="d-flex mb-3 align-items-center">
                  <div className="back_heatp_modal">
                    <Tooltip title={'Back'}>
                      <ArrowLeftOutlined
                        onClick={() => {
                          history.goBack();
                        }}
                      />
                    </Tooltip>
                  </div>

                  <Title
                    className="mb-0 add-new-calibration"
                    level={3}
                    style={{ paddingLeft: '30px', marginTop: '5px' }}
                  >
                    {'Project Heat Profile Report Viewer'}
                  </Title>

                  <div className="new-calibration">
                    <Button
                      size="medium"
                      shape="round"
                      type="primary"
                      onClick={handleAddEmailClick}
                      style={{ marginRight: '20px' }}
                    >
                      Share Report
                    </Button>

                    {selectedHeatProfileRow && selectedHeatProfileRow.signatureRequired === 1 && (
                      <Button
                        shape="round"
                        key="apply"
                        type="primary"
                        style={{ marginRight: '20px' }}
                        disabled={
                          selectedHeatProfileRow?.pdfReportDetails?.['preparedBySign']?.IsSigned &&
                          selectedHeatProfileRow?.pdfReportDetails?.['approvedBySign']?.IsSigned &&
                          selectedHeatProfileRow?.pdfReportDetails?.['approved2BySign']?.IsSigned
                        }
                        onClick={() => {
                          setSelectedViewRow(selectedHeatProfileRow);
                          setOpenSignaturePad(true);
                        }}
                      >
                        Signature
                      </Button>
                    )}
                  </div>
                </div>
                <div className="custom-line" />
                <div className="pdf-container" style={{ backgroundColor: 'transparent' }}>
                  <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                    <Viewer fileUrl={outputFile} plugins={[defaultLayoutPluginInstance]} />
                  </Worker>

                  <Drawer
                    title="Signature"
                    placement="right"
                    onClose={closeDrawer}
                    open={OpenSignaturePad}
                    width="32%"
                    className="pipeline-modal Filter-Drawer signature-canvas"
                  >
                    <div className="drawer-content">
                      <Layout className="content-scrollable">
                        <Content>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '5px',
                              backgroundColor: 'transparent',
                            }}
                          >
                            {!selectedViewRow?.pdfReportDetails?.['preparedBySign']?.IsSigned && (
                              <div>
                                <SignaturePad
                                  OpenSignaturePad={OpenSignaturePad}
                                  setOpenSignaturePad={setOpenSignaturePad}
                                  tittle={'Prepared By'}
                                  OngenrateSignedPdf={onGenerateSignedPdf}
                                />
                              </div>
                            )}
                            {!selectedViewRow?.pdfReportDetails?.['approvedBySign']?.IsSigned && (
                              <div>
                                <SignaturePad
                                  OpenSignaturePad={OpenSignaturePad}
                                  setOpenSignaturePad={setOpenSignaturePad}
                                  tittle={'Approver 1'}
                                  OngenrateSignedPdf={onGenerateSignedPdf}
                                />
                              </div>
                            )}
                            {!selectedViewRow?.pdfReportDetails?.['approved2BySign']?.IsSigned && (
                              <div>
                                <SignaturePad
                                  OpenSignaturePad={OpenSignaturePad}
                                  setOpenSignaturePad={setOpenSignaturePad}
                                  tittle={'Approver 2'}
                                  OngenrateSignedPdf={onGenerateSignedPdf}
                                />
                              </div>
                            )}
                          </div>
                        </Content>
                      </Layout>

                      <div className="ps-3 add-new-calibration-filter">
                        <Footer className="fixed-footer">
                          <div>
                            <Button
                              type="primary"
                              style={{ marginTop: 16, marginLeft: 10 }}
                              onClick={(e) => closeDrawer()}
                            >
                              Cancel
                            </Button>
                            <Button
                              type="primary"
                              style={{
                                marginTop: 16,
                                marginLeft: 10,
                              }}
                              loading={SignatureSaveLoading}
                              onClick={(e) => GeneratePDFWith_sign()}
                              disabled={
                                !(
                                  // Enable if any one of the signatures has both Image and Name
                                  (
                                    (SignatureData['preparedBySign']?.Image &&
                                      SignatureData['preparedBySign']?.Name) ||
                                    (SignatureData['approvedBySign']?.Image &&
                                      SignatureData['approvedBySign']?.Name) ||
                                    (SignatureData['approved2BySign']?.Image &&
                                      SignatureData['approved2BySign']?.Name)
                                  )
                                )
                              }
                            >
                              Save Signature
                            </Button>
                          </div>
                        </Footer>
                      </div>
                    </div>
                  </Drawer>
                </div>
              </div>
            </div>
          </div>
        )}

        {isViewerOpen && selectedViewRow.imageFileDetails?.s3Url && (
          <div>
            <div>
              <div className="d-flex mb-3 align-items-center">
                <div className="back_heatp_modal">
                  <Tooltip title={'Back'}>
                    <ArrowLeftOutlined
                      onClick={() => {
                        setIsViewerOpen(false);
                      }}
                    />
                  </Tooltip>
                </div>

                <Title
                  className="mb-0 add-new-calibration"
                  level={3}
                  style={{ paddingLeft: '30px' }}
                >
                  {'Image Viewer'}
                </Title>
              </div>

              <div className="addTeamDetails">
                <ImageWithCustomToolbar
                  src={selectedViewRow.imageFileDetails.s3Url}
                ></ImageWithCustomToolbar>
              </div>
            </div>
          </div>
        )}

        {/* Email Modal */}
        {emailModalVisible && (
          <EmailModal
            visible={emailModalVisible}
            onCancel={handleEmailModalCancel}
            onSubmit={handleEmailSent}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ projectHeatProfileReducer }) => {
  const projectList = get(projectHeatProfileReducer, 'projectHeatProfileList', []);
  const isLoading = get(projectHeatProfileReducer, 'isProjectHeatProfListLoading', false);
  const listCount = get(projectHeatProfileReducer, 'ListCount', null);

  return {
    projectList,
    isLoading,
    listCount,
  };
};

const mapDispatchToProps = {
  onProjectList: fetchProjectHeatProfileList,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectHeatProfilePDFViewer);
